import { Component, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { RidBottomButton } from '../../components/rid-bottom-button/rid-bottom-button';
import { RidButton } from '../../components/rid-button/rid-button';
import { ACCURACY_COMPARISON, DURATION_COMPARISON } from '../../components/rid-feedback-comparison-toast/reading-feedback-comparisons';
import { RidFeedbackComparisonToast } from '../../components/rid-feedback-comparison-toast/rid-feedback-comparison-toast';
import { RidHorizontalPages } from '../../components/rid-horizontal-pages/rid-horizontal-pages';
import { RidInstructionModal } from '../../components/rid-instruction-modal/rid-instruction-modal';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicTitle } from '../../components/rid-mechanic-title/rid-mechanic-title';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidModalBackground } from '../../components/rid-modal-background/rid-modal-background';
import { RidRatingModal } from '../../components/rid-rating-modal/rid-rating-modal';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidWordMatrix } from '../../components/rid-word-matrix/rid-word-matrix';
import { DiceService } from '../../services/dice-service.service';

@Component({
  selector: 'rid-reading-matrix-stopwatch',
  imports: [
    RidButton,
    RidTopBar,
    RidMechanicBackground,
    RidRatingModal,
    RidFeedbackComparisonToast,
    RidInstructionModal,
    RidMechanicTitle,
    RidMechanicWrapper,
    RidMechanicContent,
    RidModalBackground,
    RidBottomButton,
    RidHorizontalPages,
    RidWordMatrix,
  ],
  templateUrl: './rid-reading-matrix-stopwatch.html',
  host: {
    class: 'block',
  },
})
export class RidReadingMatrixStopwatch implements OnInit, OnDestroy {
  protected readonly accuracyComparison = ACCURACY_COMPARISON;
  protected readonly durationComparison = DURATION_COMPARISON;
  private readonly $diceService = inject(DiceService);

  matrices = input.required<string[][][]>();
  previousDuration = input<number>();
  previousAccuracy = input<number>();

  index = signal(0);
  state = signal<
    | { type: 'INSTRUCTION' }
    | { type: 'READING' }
    | { type: 'FEEDBACK'; duration: number }
    | { type: 'RATING' }
    | { type: 'ACCURACY_FEEDBACK'; accuracy: number }
    | { type: 'VIEWING' }
  >({
    type: 'INSTRUCTION',
  });

  finished = output<{ duration: number | undefined; accuracy: number | undefined }>();

  startTime = new Date();
  endTime: Date | undefined;
  duration: number | undefined;
  accuracy: number | undefined;

  ngOnInit(): void {
    this.$diceService.isNumericDiceAvailable.set(true);
  }

  ngOnDestroy(): void {
    this.$diceService.isNumericDiceAvailable.set(false);
  }

  start() {
    this.startTime = new Date();
    this.state.set({ type: 'READING' });
  }

  finishReading() {
    this.endTime = new Date();
    this.duration = this.endTime.getTime() - this.startTime.getTime();
    this.state.set({ type: 'FEEDBACK', duration: Math.round(this.duration / 1000) });
  }

  rate(accuracy: number) {
    this.accuracy = accuracy;
    this.state.set({ type: 'ACCURACY_FEEDBACK', accuracy });
  }

  finish() {
    this.finished.emit({ duration: this.duration, accuracy: this.accuracy });
  }
}
